
import { AccountRequestState } from '../enums';

export const AccountRequestStates = [
  { name: 'Pending', value: AccountRequestState.Pending },
  { name: 'Used', value: AccountRequestState.Used },
  { name: 'Deleted', value: AccountRequestState.Deleted },
  { name: 'Expired', value: AccountRequestState.Expired },
];
